// CSS/JS import

// Needed as async functions print an error
import "core-js/stable";
import "regenerator-runtime/runtime";

// RxJS
import { fromEvent } from 'rxjs';

import '../styles/index.sass';
import { library, dom, IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faGithub, faLastfm, faDiscord } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

// Image imports
import lazyPlaceholder from '../images/lazyPlaceholder.svg'
import Buddy from "../images/bthunderstruck.png";
import BearBg from '../images/bearbear.png'

// oh? whats this?
import temp_analyticsConsentBuddy from '../images/analytics-consent-buddy.png'
import temp_analyticsConsentConsentedBuddy from '../images/analytics-consent-constented-buddy.png'
import temp_analyticsConsentDidntConsent from '../images/analytics-consent-didnt-consent.png'
import temp_buddyBouncer from '../images/buddy-bouncer.png'
import temp_devAnalyticsConsentBuddy from '../images/dev-analytics-consent-buddy.png'
import temp_devErrored from '../images/dev-errored.png'
import temp_machigaiDodododo from '../images/machigai-dodododo.png'
import temp_machigaiShitsurei from '../images/machigai-shitsurei.png'
import temp_maintenanceServerSleepyAlt from '../images/maintenance-server-sleepy-alt.png'
import temp_maintenanceServerSleepy from '../images/maintenance-server-sleepy.png'
import temp_maintenanceServerSleepyAlt2 from '../images/maintenance-server-sleepy-alt2.png'

// Code splitting
// import '../konami';
import '../showEmail';
import '../showDiscord';
import localBucket from '../localBucket';
// import { FlagEnvironment } from '../flaggy/init'
// GraphQL queries
import checkMemoryFlag from "../gql/CheckMemoryFlag.graphql"

// Interfaces
import { CosmoQLMemoryResponse } from '../interfaces/CosmoQLMemoryResponse'

// React stuff
import React, { lazy, Suspense } from 'react';
import { ApolloClient, ApolloProvider, InMemoryCache, gql } from '@apollo/client';
import en from "../lib/lng/en";

const client = new ApolloClient({
    // uri: 'http://localhost:3444',
    uri: 'https://cosmoql.prod.plusreed.com',
    cache: new InMemoryCache({
        typePolicies: {
            Query: {
                fields: {
                    prFlags: {
                        merge(existing, incoming) {
                            return { ...existing, ...incoming }
                        }
                    }
                }
            }
        }
    })
})

const LastFm = lazy(() => import(/* webpackChunkName: "react.lastfm" */'../components/LastFm'))
const Announcement = lazy(() => import(/* webpackChunkName: "react.announcement" */'../components/Announcement'))
const Masthead = lazy(() => import(/* webpackChunkName: "react.masthead" */'../components/Masthead/masthead'))

// import used icons
// TODO: I'm not entirely sure what's up with this,
// but some update I did completely fucked the types for this.
library.add(
    (faGithub as IconDefinition),
    (faLastfm as IconDefinition),
    (faDiscord as IconDefinition),
    (faEnvelope as IconDefinition)
)
// watch the dom to do i2svg
dom.watch()

// Handle clicks on Discord/email buttons.
let discordBtn = document.querySelector('.discord');
let emailBtn = document.querySelector('.email');
let memoryBtn = document.querySelector('#memoryFlagButton')

discordBtn?.addEventListener('click', async () => {
    const module = await import('../showDiscord' /* webpackChunkName: "socials.actions.discord" */)
    module.showDiscord()
})

// discordBtn && fromEvent(discordBtn, 'click').subscribe(() => {
//     import(/* webpackChunkName: "socials.actions.discord" */'../showDiscord').then(module => {
//         module.showDiscord();
//     });
// });

emailBtn && fromEvent(emailBtn, 'click').subscribe(() => {
    import(/* webpackChunkName: "socials.actions.email" */'../showEmail').then(module => {
        module.showEmail();
    });
});

memoryBtn?.addEventListener('click', async () => {
    const { data }: CosmoQLMemoryResponse = await client.query({
        query: checkMemoryFlag
    })

    const memory = data.prFlags.easterEggs.memory

    if (memory.enabled) {
        const { default: memoryFn } = await import('../lib/eggs/memory' /* webpackChunkName: "eggs.memory" */)
        memoryFn(memory.rootElement, memory.audioPath)
    }
})

// memoryBtn && fromEvent(memoryBtn, 'click').subscribe(async () => {
//     const { data }: CosmoQLMemoryResponse = await client.query({
//         query: checkMemoryFlag
//     })

//     const memory = data.prFlags.easterEggs.memory

//     if (memory.enabled) {
//         import(/* webpackChunkName: 'egg.memory' */'../lib/eggs/memory').then(module => {
//             module.default(memory.rootElement, memory.audioPath)
//         })
//     }
// })

// Auto-update subtitle based on date.
function determineAge (date: string): number {
    const today = new Date()
    const birthDate = new Date(date)
    let age = today.getFullYear() - birthDate.getFullYear()
    const m = today.getMonth() - birthDate.getMonth()

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--
    }

    return age
}

document.addEventListener('DOMContentLoaded', () => {
    const subtitle = document.querySelector('[data-age]')
    const _age = determineAge('June 5, 2001 00:00:00')

    if (subtitle === null) {
        throw new Error(en.errorSubtitleNull)
    }

    subtitle.textContent = `I'm a ${_age} year old developer of sorts.`

    if (localBucket.bearTileBg) {
        // Add the bear background
        const body = document.querySelector('body')
        body?.setAttribute('style', `background-image: url(${BearBg}); background-repeat: repeat;`)
    }
})

// fromEvent(document, 'DOMContentLoaded').subscribe(async () => {
//     const subtitle = document.querySelector('[data-age]')
//     const _age = determineAge('June 5, 2001 00:00:00')

//     if (subtitle === null) {
//         throw new Error(en.errorSubtitleNull)
//     }

//     subtitle.textContent = `I'm a ${_age} year old developer of sorts.`
// })

/* flagsmith stuff, not used atm so commenting out
import(webpackChunkName: "core.flaggy" '../flaggy/init').then(module => {
    module.default(
        process.env.NODE_ENV === 'production'
        ? FlagEnvironment.Production
        : FlagEnvironment.Development
    )
})
*/

import(/* webpackChunkName: "core.utility" */'../utility').then(module => {
    if (location.hostname === "localhost") {
        console.log(en.skippingCosmoChecksOnLocal)
    } else {
        console.time(en.cosmoCheckingStatus);
        module.getCosmoStatus();
        console.timeEnd(en.cosmoCheckingStatus);
    
        console.time(en.cosmoGetPrcomPageCfg);
        module.getPrComPageConfig();
        console.timeEnd(en.cosmoGetPrcomPageCfg);
    
        console.time(en.cosmoGetPrcomFlags);
        module.getPrComFlags()
        console.timeEnd(en.cosmoGetPrcomFlags);
    }
});

import(/* webpackChunkName: "lib.reactDom" */'react-dom').then(module => {
    client.query({
        query: gql`
            # get polling interval from flags
            query GetPollingInterval {
                prFlags {
                    lastFmGql {
                        pollingInterval
                    }
                }
            }
        `
    }).then(result => {
        module.render(
            <Suspense fallback={<p>{en.waitingOnLastFm}</p>}>
                <ApolloProvider client={client}>
                    <LastFm pollInterval={result.data.prFlags.lastFmGql.pollingInterval} />
                </ApolloProvider>
            </Suspense>,
            document.querySelector('[data-lfm-react-root]')
        );
    })

    if (localBucket.exp830_enableReactMasthead) {
        document.querySelector('.fursona').remove();
        module.render(
            <Suspense fallback={<img className="rounded fursona" src={lazyPlaceholder} aria-hidden={true} alt={""} />}>
                <Masthead />
            </Suspense>,
            document.querySelector('[data-mastroot]'),
        );
    } else { import('../fursona'); }

    if (localBucket.exp829_disableTopAnnouncementBar) {
        return console.log(en.announcementDisabled); 
    } else {
        module.render(
            <Suspense fallback={<p>{en.loadingAnnouncement}</p>}>
                <Announcement />
            </Suspense>,
            document.querySelector('[data-react-alert]'),
        );
    }
});

if (localBucket.exp829_disableToyboxIntegration) {
    console.log(en.toyboxDisabled);
} else {
    import(/* webpackChunkName: "lib.toybox" */'../toyboxLoader').then(module => {
        module.default();
    });
}

import(/* webpackChunkName: "core.sentry" */'../sentryReporting')
